import styled from 'styled-components'

import {
    RowFlex,
    FlexJustifyContentCenter,
    FlexJustifyContentSpaceBetween,
    FlexAlignItemsCenter,
} from 'components/common/genericStyles'
import { Color } from 'constants/color'

export const Container = styled.div`
    ${RowFlex};
    ${FlexJustifyContentCenter};
`

export const CenterControls = styled.div`
    ${RowFlex};
    ${FlexJustifyContentCenter};
`

export const ChatButtonContainer = styled.div`
    // margin-left: 32px;
`

export const LeftControls = styled.div`
    display: flex;
    position: absolute;
    left: 32px;
`

export const RightControls = styled.div`
    display: flex;
    position: absolute;
    right: 32px;
    > * {
        margin: 0px 2.5px;
    }
`

export const AudioVideoContainer = styled.div`
    ${RowFlex};
    ${FlexAlignItemsCenter};
    ${FlexJustifyContentSpaceBetween};

    width: 114px;
    height: 40px;
    margin-left: 16px;
    background: ${Color.unknownColor19};
    padding: 12px 16px 12px 20px;
    border-radius: 44px;
`

export const AudioVideoSeparator = styled.div`
    width: 1px;
    background: ${Color.unknownColor22};
    height: 90%;
`
